import React from 'react'
import Embed16x9 from '@/components/Common/Embed16x9'

const WPGHtmlBlock = props => {
  const id = Math.floor(Math.random() * 100000)
  const { attrs, innerBlocks, innerHTML } = props

  const scriptHtml = innerHTML.replace(
    /<script(>|\s)/gm,
    `<script data-script="${id}"$1`,
  )

  if (attrs.url && attrs.url.includes('youtube.com/embed')) {
    const iframeCode = `<iframe width="560" height="315" src="${attrs.url}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    return (
      <div className="wp-block block--embed block--embed-youtube">
        <Embed16x9 iframe={iframeCode} />
      </div>
    )
  }

  return (
    <div
      className="wp-block block--html"
      dangerouslySetInnerHTML={{ __html: scriptHtml }}
    />
  )
}

export default WPGHtmlBlock
